import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { listWineVarietals } from 'redux/productFilters/actions';

class WineVarietalFilter extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const queryObj = queryString.parse(location.search);
    this.state = {
      wineVarietal: queryObj.wineVarietal
    };
  }

  componentDidMount() {
    this.listWineVarietals();
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listWineVarietals();
    }
  }

  listWineVarietals = () => {
    const { props } = this;
    const { slug } = props.match.params;
    props.listWineVarietals(slug);
  };

  handleChange = (e) => {
    const wineVarietal = e.target.value;
    this.setState({ wineVarietal });
    this.handleQueryChange(wineVarietal);
  };

  handleQueryChange = (wineVarietal) => {
    const { location, history } = this.props;
    const parsed = queryString.parse(location.search);
    if (wineVarietal === '') {
      delete parsed.wineVarietal;
    } else {
      parsed.wineVarietal = wineVarietal;
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  render() {
    const { wineVarietals } = this.props;
    const { wineVarietal } = this.state;
    if (wineVarietals.length === 0) {
      return null;
    }
    return (
      <>
        <div className="c7-selectbox">
          <label htmlFor="wineVarietal">
            Varietal:
            <span className="c7-selectboxWrap">
              <select
                id="wineVarietal"
                name="wineVarietal"
                value={wineVarietal}
                onChange={this.handleChange}
              >
                <option value="" />
                {wineVarietals.map((wt) => (
                  <option value={wt.wineVarietal} key={wt.wineVarietal}>
                    {wt.wineVarietal}
                  </option>
                ))}
              </select>
            </span>
          </label>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  wineVarietals: state.productFilter.wineVarietals
});

export default withRouter(
  connect(mapStateToProps, { listWineVarietals })(WineVarietalFilter)
);
